<template>
	<div class="l-edit-dialog-box" style="max-height: 75vh; height: 75vh" v-loading="loading">
		<el-form :model="form_data" label-width="110px" ref="form" :rules="rules" label-position="left">
			<el-row :gutter="30">
				<el-col :span="12">
					<el-form-item label="归还日期" prop="back_date">
						<el-date-picker v-model="form_data.back_date" type="date" style="width: 100%" placeholder="选择日期" value-format="yyyy-MM-dd"> </el-date-picker>
					</el-form-item>
				</el-col>
			</el-row>
			<el-form-item label="备注" prop="remark">
				<el-input type="textarea" autosize placeholder="请输入备注" v-model="form_data.remark"> </el-input>
			</el-form-item>
		</el-form>

		<!--已选的资产-->
		<l-divider></l-divider>
		<div>
			<div style="margin-bottom: 10px">
				<div class="l-text-btn" @click="selecAssets">选择资产</div>
				<l-text-button type="danger" :disabled="del_selected_ids.length == 0" style="margin-left: 10px" @click="multiDel">批量移除</l-text-button>
				<span style="float: right">已选 {{ form_data.assets_ids.length }} 个</span>
			</div>
			<l-assets-common-table ref="assets_table" :data="selected_assets" @selection-change="handleSelectionChange" @del="del" row-key="id"></l-assets-common-table>
		</div>

		<!--打开选择资产界面-->
		<l-dialog :visible.sync="show_select_assets" title="选择归还资产" width="1000px">
			<l-assets-common-select @on-select="onSelectSuccess" :type="4" :select-ids="form_data.assets_ids" :visible.sync="show_select_assets" />
		</l-dialog>

		<div class="l-dialog-footer">
			<el-button @click="cancel">取 消</el-button>
			<el-button type="primary" @click="handleSubmit" :loading="submitting">确 定</el-button>
		</div>
	</div>
</template>

<script>
import { dateToStr } from "@/utils/Fuc";
import AssetsTable from "../assets/CommonTable";
import CommonSelect from "../assets/CommonSelect";
export default {
	name: "l-assets-back-edit",
	components: {
		[AssetsTable.name]: AssetsTable,
		[CommonSelect.name]: CommonSelect,
	},
	props: {
		id: {
			type: [Number, String],
			default: null,
		},
		visible: {
			type: Boolean,
		},
	},
	computed: {
		hasId() {
			return this.$props.id !== null;
		},
	},
	data() {
		return {
			loading: false,

			show_select_assets: false,

			is_first: true,

			//表单数据
			submitting: false,

			del_selected_ids: [],

			selected_assets: [],

			form_data: {
				assets_ids: [],
				back_date: dateToStr(new Date(), "date"),
				remark: "",
			},

			rules: {
				back_date: [{ required: true, message: "请选择归还时间", trigger: "change" }],
			},
		};
	},

	watch: {
		visible: {
			immediate: true,
			handler(val) {
				if (val) {
					this.getData();
				}
			},
		},
	},

	methods: {
		//点击取消通知父组件关闭对话框
		cancel() {
			this.$emit("update:visible", false);
		},
		//获取添加数据
		getData() {
			if (this.hasId) {
				//获取重新申请信息
				this.loading = true;
				this.$_invoke("assetsBack_getReapplyData", { id: this.$props.id })
					.then((ret) => {
						this.form_data = ret.form_data;
						this.selected_assets = ret.selected_assets;
					})
					.finally(() => {
						this.loading = false;
					});
			} else {
				// this.is_first = false;
				// //添加获取数据
				// this.loading = true;
				// this.$_invoke("assetsRecv_getAddData")
				// 	.then((ret) => {
				// 		this.org_tree = ret.org_tree;
				// 	})
				// 	.finally(() => {
				// 		this.loading = false;
				// 	});
			}
		},

		//显示资产选择
		selecAssets() {
			this.show_select_assets = true;
		},

		//选择资产成功回调
		onSelectSuccess(select_assets_ids, select_data) {
			this.show_select_assets = false;
			select_assets_ids.forEach((item) => {
				const index = this.form_data.assets_ids.findIndex((itm) => {
					return item == itm;
				});
				if (index == -1) {
					this.form_data.assets_ids.push(item);
				}
			});
			select_data.forEach((item) => {
				const index = this.selected_assets.findIndex((itm) => {
					return item.id == itm.id;
				});
				if (index == -1) {
					this.selected_assets.push(item);
				}
			});
		},

		//监听多选框选择
		handleSelectionChange(val) {
			this.del_selected_ids = [];
			val.forEach((item) => {
				this.del_selected_ids.push(item.id);
			});
		},

		//批量移除
		multiDel() {
			console.log(this.del_selected_ids);
			this.del_selected_ids.forEach((del_id) => {
				this.del(
					{
						id: del_id,
					},
					true
				);
			});
			//清空所有已选项
			this.del_selected_ids = [];
		},

		//移除单条数据
		del(row, is_multi = false) {
			console.log(row);
			const index = this.selected_assets.findIndex((item) => {
				return item.id == row.id;
			});

			if (index != -1) {
				this.selected_assets.splice(index, 1);
			}

			const id_index = this.form_data.assets_ids.findIndex((item) => {
				return item == row.id;
			});

			if (id_index != -1) {
				this.form_data.assets_ids.splice(id_index, 1);
			}

			if (!is_multi) {
				const del_index = this.del_selected_ids.findIndex((item) => {
					return item == row.id;
				});

				if (del_index != -1) {
					this.del_selected_ids.splice(del_index, 1);
				}
			}
		},

		//提交数据
		handleSubmit() {
			if (this.loading) return;
			this.$refs.form.validate((valid) => {
				if (valid) {
					if (this.form_data.assets_ids.length == 0) {
						this.$_msg.error("请至少选择一个归还资产");
						return;
					}
					this.submitting = true;
					//添加
					this.$_invoke("assetsBack_save", this.form_data)
						.then(() => {
							this.$_msg.success("提交成功");
							this.$emit("on-success");
						})
						.finally(() => {
							this.submitting = false;
						});
				}
			});
		},
	},
};
</script>
